import useEmpleadosList from "./useEmpleadosList";
import useEmpleadoForm from "./useEmpleadoForm";

export default function useEmpleadosLogic() {
  const list = useEmpleadosList();

  const form = useEmpleadoForm({
    onCreated: (nuevo) => list.upsertEmpleado(nuevo),
    onUpdated: (actualizado) => {
      list.upsertEmpleado(actualizado);
      if (list.seleccionado?.id === actualizado.id) list.setSeleccionado(actualizado);
    },
    onDeleted: (eliminado) => {
      list.removeEmpleado(eliminado.id);
      if (list.seleccionado?.id === eliminado.id) list.setSeleccionado(null);
    },
  });

  return { ...list, form };
}
